import { exportHack } from '../../utils/exportHack';
import { ButtonPicker, } from './ButtonPicker';
import { ButtonPickerButton, } from './ButtonPickerButton';
import { layouts, sizes, } from './constants';
const ExportHackButtonPicker = (exportHack({
    component: ButtonPicker,
    constants: {
        Button: ButtonPickerButton,
        layouts,
        sizes,
    },
}));
export { ExportHackButtonPicker as ButtonPicker, ButtonPickerButton, };
